import { render, staticRenderFns } from "./empresa-form.vue?vue&type=template&id=501d9b47&scoped=true"
import script from "./empresa-form.vue?vue&type=script&lang=js"
export * from "./empresa-form.vue?vue&type=script&lang=js"
import style0 from "./empresa-form.vue?vue&type=style&index=0&id=501d9b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d9b47",
  null
  
)

export default component.exports